module.exports = __webpack_public_path__ + "static/media/bg-desk-1.98dec7c5.jpg";